<template>
  <span id="print-ccn-bol" v-show="dropId && dropId > 0 && bolId && bolId > 0">
    <el-tooltip class="item" effect="dark" :content="$t('outbound.loads.printCcnBol')" placement="top-start">
      <i class="el-icon-printer icon-action" @click="dialogVisible = true" />
    </el-tooltip>
    <el-dialog width="25%" :close-on-click-modal="false" :visible.sync="dialogVisible" :title="$t('outbound.loads.printDocuments')" class="dialog-with-cols">
      <el-row v-if="dropId && dropId > 0">
        <el-col>
          <el-button plain icon="el-icon-document" @click="printCcn()">{{ $t('outbound.loads.ccn') }}</el-button>
        </el-col>
      </el-row>
      <el-row v-if="bolId && bolId > 0">
        <el-col>
          <el-button plain icon="el-icon-notebook-2" @click="printDetailedBol()">{{ $t('outbound.loads.detailedBol') }}</el-button>
        </el-col>
      </el-row>
      <el-row v-if="bolId && bolId > 0">
        <el-col>
          <el-button plain icon="el-icon-notebook-2" @click="printBol()">{{ $t('outbound.loads.bol') }}</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </span>
</template>

<script>
import { Loading } from 'element-ui';
import constants from '@/utils/constants';

export default {
  name: 'PrintCcnBol',
  props: {
    dropId: {
      type: Number,
      default: null
    },
    bolId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  methods: {
    async printCcn() {
      const loading = Loading.service(constants.LOADING.PRINT_DELIVER_TO_LOAD);
      await this.$store.dispatch('loads/printDeliverToLoad', { dropId: this.dropId, bolId: this.bolId })
        .finally(() => loading.close());
      this.dialogVisible = false;
    },
    async printDetailedBol() {
      const loading = Loading.service(constants.LOADING.PRINT_DETAILED_BILL_OF_LADING);
      await this.$store.dispatch('billOfLading/printDetailed', this.bolId)
        .finally(() => loading.close());
      this.dialogVisible = false;
    },
    async printBol() {
      const loading = Loading.service(constants.LOADING.PRINT_BILL_OF_LADING);
      await this.$store.dispatch('billOfLading/print', this.bolId)
        .finally(() => loading.close());
      this.dialogVisible = false;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
#print-ccn-bol {
  .el-button {
    margin-bottom: 10px;
    width: 100%;
  }
}
</style>
